import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class NextStep extends DesigntimeComponent {
    static staticName = "Next Step";
    static staticId = "nextStep";
    runtimeUrlParams = [];

    constructor(identifyer) {
        super(identifyer, 2);

        this.disableNextButton();
        this.hasNextButton = false;

        this.values = {
            header: { value: "Default **header** text" },
            text: { value: "Default text" },
            link: { value: "jas", dontTranslate: true },
            linkText: { value: "jas" },
            buttontext: { value: "" }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));

        var $view = $("<div></div>");
        var $textbox = $("<div class='sid-question-text'></div>");
        $textbox.append("<h3>" + this.values.header.value + "</h3>")
        $textbox.append("<p>" + this.values.text.value + "</p>")
        $textbox.append($("<div class='link-placeholder'></div>"));
        $view.append($textbox);
        return $view;
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == "url") {
            this.runtimeUrlParams.push(eventParams);
        }
        var $link = $(`<a href='${this.getNextUrl(this.values.link.value)}'>${this.values.linkText.value}</a>`)
        componentHelpers.getRtFrame(this.id).find(".link-placeholder").empty().append($link);
    }

    getNextUrl(nextStep) {
        var link = "Index.html?";
        for (var paramIndex in this.runtimeUrlParams) {
            if (link.substr(-1) != "&")
                link += "&";
            var param = this.runtimeUrlParams[paramIndex];
            var paramName = param.key.replace("url:", "");

            if (paramName == "bmiName") {
                link = link + `bmiName=${nextStep}`
            } else {
                link = link + `${paramName}=${param.value}`
            }
        }
        return link;
    }

    importModel(model) {
        super.importModel(model);
        if (model.version == 1) {
            this.values.linkText = { value: this.values.link.value };
            this.version = 2;
        }
    };
}

export { NextStep }
